import QuizSelection from './QuizSelection'
import TopBar from '@renderer/components/TopBar'
import { useQuiz } from '@renderer/lib/useQuiz'
import QuizPage from './QuizPage'
import QuizEndPage from './QuizEndPage'

const HomePage = () => {
  const { currentQuiz, isQuizEnded } = useQuiz()

  return (
    <div className="flex flex-col h-dvh max-h-dvh overflow-hidden bg-white w-full">
      <TopBar />
      <div className="flex-1 min-h-0 flex flex-col items-center justify-center overflow-hidden">
        {!currentQuiz ? (
          <QuizSelection />
        ) : isQuizEnded ? (
          <QuizEndPage />
        ) : (
          <QuizPage />
        )}
      </div>
    </div>
  )
}

export default HomePage
